// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingBlock_root__tD8yi"};